import { request } from "../utils/request.js"

export const purchaseReturnOrder_exportForManage = (pojo, args) => request({
    url: 'purchaseReturnOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseReturnOrder_findPageForManage = (pojo, args) => request({
    url: 'purchaseReturnOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseReturnOrder_findPageListForManage = (pojo, args) => request({
    url: 'purchaseReturnOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseReturnOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'purchaseReturnOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseReturnOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'purchaseReturnOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseReturnOrder_findPageForSelect = (pojo, args) => request({
    url: 'purchaseReturnOrder/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseReturnOrder_findPageListForSelect = (pojo, args) => request({
    url: 'purchaseReturnOrder/findPageListForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseReturnOrder_saveIntoDraft = (pojo, args) => request({
    url: 'purchaseReturnOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseReturnOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'purchaseReturnOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseReturnOrder_update = (pojo, args) => request({
    url: 'purchaseReturnOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseReturnOrder_updateAndSubmit = (pojo, args) => request({
    url: 'purchaseReturnOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseReturnOrder_submitById = (id, args) => request({
    url: 'purchaseReturnOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseReturnOrder_deleteById = (id, args) => request({
    url: 'purchaseReturnOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseReturnOrder_approval = (pojo, args) => request({
    url: 'purchaseReturnOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseReturnOrder_findById = (id, args) => request({
    url: 'purchaseReturnOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const purchaseReturnOrder_findVoById = (id, args) => request({
    url: 'purchaseReturnOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const purchaseReturnOrder_generatePrintPdf = (pojo, args) => request({
    url: 'purchaseReturnOrder/generatePrintPdf',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/purchaseReturnOrder.js